export default __webpack_public_path__ + "static/media/WOMO.adc0873b.png";